var vent;

if (window.GMap == null) {
  window.GMap = {};
}

GMap.vent = vent = _(Backbone.Events).clone();

module.exports = {
  vent: vent
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9nX21hcC9mcm9udGVuZC9oZWxwZXJzL2V2ZW50cy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ha2VzaGFyaS9uYXBpc3RyYW5vL2J1aWxkLzE0OTU2NjA4OTgyNDktNDM5Ni9wcm9kdWN0aW9uLTIwMTcuMDUuMjRfMjEuMTkvZGVhbC9tb2R1bGVzL2dfbWFwL2Zyb250ZW5kL2hlbHBlcnMvZXZlbnRzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOzs7RUFBQSxNQUFNLENBQUMsT0FBUTs7O0FBRWYsSUFBSSxDQUFDLElBQUwsR0FBWSxJQUFBLEdBQ1YsQ0FBQSxDQUFFLFFBQVEsQ0FBQyxNQUFYLENBQWtCLENBQUMsS0FBbkIsQ0FBQTs7QUFFRixNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUFDLE1BQUEsSUFBRCJ9
